<template>
  <div class="select_container">
    <div
      :class="`select_wrapper ${isOpen ? 'select_selected' : ''}`"
      @click="handleClick"
    >
      <p :class="`body_7 ${!!value ? 'f_gray_2' : 'f_gray_4'}`">
        {{ selectedName }}
      </p>
      <img
        :class="`${isOpen ? 'is_open' : ''}`"
        src="/static/icons/arrow/chevron_down.svg"
        alt="chevron"
      />
    </div>
    <ul v-if="isOpen" class="option_list">
      <li
        :class="
          `${
            option.value === value ? 'body_8_M f_primary_1' : 'body_8  f_gray_2'
          }`
        "
        v-for="option in options"
        :key="option.name"
        @click="() => handleClickItem(option.value)"
      >
        {{ option.name }}
        <img
          v-if="option.value === value"
          src="/static/icons/check.svg"
          alt="check"
        />
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    selected: {
      type: String
    },
    placeholder: {
      type: String,
      default: '선택'
    },
    value: {
      type: String
    },
    options: {
      type: Array
    },
    isOpen: {
      type: Boolean,
      defalut: false
    },
    onClick: {
      type: Function
    },
    onClickItem: {
      type: Function
    }
  },
  computed: {
    selectedName () {
      const selectedOption = this.options.find(option => option.value === this.value)
      return selectedOption ? selectedOption.name : this.placeholder
    }
  },
  methods: {
    handleClick () {
      if (this.onClick) {
        this.onClick()
      }
    },
    handleClickItem (value) {
      if (this.onClickItem) {
        this.onClickItem(value)
      }
    }
  }
}
</script>

<style scope>
.select_container {
  position: relative;
}
.select_container > .select_wrapper {
  padding: 10px 12px;
  border: 1px solid var(--gray-scale-7);
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.select_selected {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border: 1px solid var(--primary-color-1) !important;
}

.select_container > .select_wrapper > .is_open {
  transform: rotate(180deg);
}

.option_list {
  z-index: var(--zIndex-select);
  background-color: var(--gray-scale-12);
  position: absolute;
  top: 46px;
  width: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 1px solid var(--gray-scale-7);
  border-top: none;
  max-height: 240px;
  overflow-y: scroll;
}

.option_list > li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiSelectBox.vue